"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimateCharacterAbilityVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class AnimateCharacterAbilityVfxStepArgs {
    constructor(invokerId, ability, fallbackAnimation, speed = 1, idleAfter = fallbackAnimation !== "killed") {
        this.invokerId = invokerId;
        this.ability = ability;
        this.fallbackAnimation = fallbackAnimation;
        this.speed = speed;
        this.idleAfter = idleAfter;
        this.__typeName = "AnimateCharacterAbility";
        this.id = (0, uuid_1.v4)();
    }
}
exports.AnimateCharacterAbilityVfxStepArgs = AnimateCharacterAbilityVfxStepArgs;
